import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import colors from "../../theme/colors";

type Props = {
  selectedCells: Cell[];
};

const SummaryContent = ({ selectedCells }: Props) => {
  const buildCount: Record<string, number> = {};
  selectedCells.forEach(({ condition }) => {
    if (!buildCount[condition.cell_assembly]) {
      buildCount[condition.cell_assembly] = 0;
    }
    buildCount[condition.cell_assembly]++;
  });
  const buildCountKeys = Object.keys(buildCount);

  const electrolyteVolume: Record<string, number> = {};
  selectedCells.forEach(({ electrolyte, fill }) => {
    if (!electrolyte.icm_pcm) {
      return;
    }

    if (!electrolyteVolume[electrolyte.icm_pcm]) {
      electrolyteVolume[electrolyte.icm_pcm] = 0;
    }
    electrolyteVolume[electrolyte.icm_pcm] += fill.nominal_volume || 0;
  });
  const electrolyteVolumeKeys = Object.keys(electrolyteVolume);

  const rowCount = Math.max(
    buildCountKeys.length,
    electrolyteVolumeKeys.length,
  );

  const iterator = [...new Array(rowCount)];

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell
            style={{
              borderBottom: 0,
              borderTop: 0,
            }}
          >
            Build Type count
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody style={{ borderBottom: 0 }}>
        {iterator.map((_, index) => (
          <TableRow key={index}>
            {buildCountKeys[index] ? (
              <TableCell
                style={{
                  borderBottom: 0,
                  borderTop: 0,
                }}
              >
                <Box display="flex" alignItems="center">
                  <div style={{ color: colors.text.secondary }}>
                    {buildCountKeys[index]}
                  </div>
                  <Box ml={6}>
                    {buildCountKeys[index]
                      ? buildCount[buildCountKeys[index]]
                      : ""}
                  </Box>
                </Box>
              </TableCell>
            ) : (
              <TableCell
                style={{
                  borderBottom: 0,
                  borderTop: 0,
                }}
              >
                {index === 0 ? "NA" : ""}
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SummaryContent;
